import { SnomedConcept, FrequentSnomedParent, frequentSnomedParents } from "@/src/data/allTypes";
import { getItemId } from "@/src/utils/utils";

export default function SnomedCategoryName({
  concept,
  filteredParentIds,
}: {
  concept: SnomedConcept | null | undefined;
  filteredParentIds?: FrequentSnomedParent[];
}) {
  if (!concept) return null;
  if (filteredParentIds?.length == 1) return null;
  for (let parent of concept?.allParents || []) {
    for (const frequentParentName in frequentSnomedParents) {
      const frequentParent =
        frequentSnomedParents[frequentParentName as FrequentSnomedParent];
      if (getItemId(parent) != frequentParent.id) continue;
      return <span className="gray">{frequentParent.displayName}</span>;
    }
  }
  return null;
}
